<template>
  <div class="section">
    <div class="part part-dynamique">
      <div class="tle-row">
        <div class="tle-col half q-py-none q-my-none">
          <error v-if="firstTableError" />
          <el-table v-else :table="firstTable" />
        </div>
        <div class="tle-col half q-py-none q-my-none">
          <error v-if="secondTableError" />
          <el-table v-else :table="secondTable" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PageMixin from "@/components/study/editor/pages/page.mixin.js";

export default {
	name: "section-gie-dynamique-territoriale",
	mixins: [PageMixin],
	data: () => ({
		firstTableError: false,
		secondTableError: false,
	}),
	props: {
		main_color: { default: "" },
		firstTableComponentId: { type: String, default: "2.1.1" },
		secondTableComponentId: { type: String, default: "2.1.2" },
		firstTableComponentName: { type: String, default: "dynamique territoriale et menages 1" },
		secondTableComponentName: { type: String, default: "dynamique territoriale et menages 2" },
	},
	computed: {
		...mapGetters([
			"active_study",
			"editor",
			"app_parameters",
		]),
		firstTableComponent () {
			try {
				return this.active_study.qlikData.component.find((component) => {
					return component.name == this.firstTableComponentName || component.id == this.firstTableComponentId;
				});
			} catch (e) {
				this.firstTableError = true;
			}
			return null;
		},
		secondTableComponent () {
			try {
				return this.active_study.qlikData.component.find((component) => {
					return component.name == this.secondTableComponentName || component.id == this.secondTableComponentId;
				});
			} catch (e) {
				this.secondTableError = true;
			}
			return null;
		},
		firstTable () {
			this.firstTableError = false;

			try {
				const table = {
					head: [],
					body: [],
					config: {
						cols_width: [30, 15, 15, 15, 15],
					},
				};

				table.head.push(
					this.firstTableComponent.content.global.header_list.map(
						(header) => header.value
					)
				);

				table.body = this.firstTableComponent.content.global.data_list.map(
					(data) => [
						data.label,
						...data.values.map((item) => item.unit=="" || item.unit==null? `${this.moneyParse(item.value)}`:`${item.value}${item.unit}`),
					]
				);

				return table;
			} catch (e) {
				this.firstTableError = true;
			}
			return null;
		},
		secondTable () {
			this.secondTableError = false;

			try {
				const table = {
					head: [],
					body: [],
					config: {
						cols_width: [30, 15, 15, 15, 15],
					},
				};

				table.head.push(
					this.secondTableComponent.content.global.header_list.map(
						(header) => header.value
					)
				);
				
				table.body = this.secondTableComponent.content.global.data_list.map(
					(data) => [
						data.label,
						...data.values.map((item) => item.unit=="" || item.unit==null? `${this.moneyParse(item.value)}`: `${item.value}${item.unit}`),
					]
				);

				return table;
			} catch (e) {
				this.secondTableError = true;
			}
			return null;
		},
	},
};
</script>

<style lang="stylus" scoped>
@import '../../../../../assets/css/app';
@import '../../../../../assets/css/page';
</style>

<style lang="scss">
.part-dynamique {
  .el-table .table {
    font-size: 9px;
    tr td {
      padding: 4px;
    }
  }
}
</style>